<template>
  <section class="main_content">
    <div class="shopping_game">
      <h2>{{$t('playAndWin')}}</h2>
      <!-- <div v-if="$cookie.get('version-code') <= 97">
      <ul
        class="game_card"
        @click="OnSubmit('bidding-product-list/')"
        style="background-color: #b2c4ec;"
      >
        <li class="card_section">
          <div class="img_wrapper">
            <img :src="require(`../assets/images/detail/bidding.svg`)" alt="random image" />
          </div>
          <div class="card_content">
            <h3>{{$t('kiranaBidding')}}</h3>
            <ul>
              <li>
                <span></span>
                {{this.$t("bidUsingMpoints")}}
              </li>
              <li>
                <span></span>
                {{this.$t("fullHoursTime", {time: '24'})}}
              </li>
              <li>
                <span></span>
                {{this.$t('highestBidWins')}}
              </li>
              <li>
                <span></span>
                {{this.$t('getProductForFree')}}
              </li>
            </ul>
          </div>
        </li>
        <li class="button_wrapper">
          <button type="button" class="buy_now">{{$t('buyNow')}}</button>
        </li>
      </ul>
      </div> -->
      <div v-if="$cookie.get('version-code') >= 98">
      <ul
        class="game_card"
        v-for="(game_list,index) in shopping_game_List "
        :key="index"
        @click="OnSubmit(game_list.link)"
        
      >
        <li class="card_section">
          <div class="img_wrapper">
            <img :src="require(`../assets/images/detail/${game_list.img}`)" alt="random image" />
          </div>
          <div class="card_content">
            <h3>{{game_list.title}}</h3>
            <ul>
              <li v-for="(list,inner_Index) in game_list.inner_Details " :key="inner_Index">
                <span></span>
                {{list}}
              </li>
            </ul>
          </div>
        </li>
        <li class="button_wrapper">
          <button type="button" class="buy_now">{{$t('buyNow')}}</button>
        </li>
      </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ShoppingGame",
  data() {
    return {
      shopping_game_List: [

        // {
        //   img: "Mega Discount.svg",
        //   title: this.$t("groupMegaDiscount"),
        //   link: "groups-product-listing/",
        //   inner_Details: [
        //     this.$t("createAGroup"),
        //     this.$t("invitefriends"),
        //     this.$t("completeGroup"),
        //     this.$t("saveTogether")
        //   ]
        // },
        // {
        //   img: "bidding.svg",
        //   title: this.$t('kiranaBidding'),
        //   link: "bidding-product-list/",
        //   inner_Details: [
        //     this.$t("bidUsingMpoints"),
        //     this.$t("fullHoursTime", {time: '24'}),
        //     this.$t('highestBidWins'),
        //     this.$t('getProductForFree')
        //   ]
        // },
        {
          img: "bidding.svg",
          title: this.$t('lifestyleBidding'),
          link: "lifeStyleGame",
          inner_Details: [
            this.$t("bidUsingMpoints"),
            this.$t("fullHoursTime", {time: '24'}),
            this.$t('highestBidWins'),
            this.$t('getProductForFree')
          ]
        },
        {
          img: "cuttheprice.png",
          title: this.$t("cutThePrice"),
          link: "cutPriceGame",
          inner_Details: [
            this.$t("selectProduct"),
            this.$t("addYourFriend"),
            this.$t("lessAmount"),
            this.$t("getInFree")
          ]
        },
        {
          img: "oye-lucky.png",
          title: "OYE LUCKY LUCKY OYE",
          link: "oyeOyeLuckyGame",
          inner_Details: [
            this.$t("selectProduct"),
            this.$t("clickOnLuckydraw"),
            this.$t('shareWithFrnds'),
            this.$t('oneLuckyWinner')
          ]
        }
      ],
    };
  },
  mounted() {},
  methods: {
    OnSubmit(link) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        if(link === 'bidding-product-list/'){
          this.$router.push(`/${link}`);
        }else{
          let openLink;
          if(link === 'lifeStyleGame'){
            openLink = 'bidding-product-list/'
          }else if(link === 'cutPriceGame'){
            openLink = 'cutprice-product-listing/'
          }else if(link === 'oyeOyeLuckyGame'){
            openLink = 'oye-lucky-lucky-oye-listing/'
          }
          let id = 137;
          let applicationUrl =
            `https://www.mall91.com/#/${openLink}`;
          let appName = "mall91";
          let iconImageUrl =
            "https://cdn.mall91.com/adeb3918-d492-43ed-86a6-ae4140ce05ec_original.jpg";
          try {
            JSBridgePlugin.openMiniAppWithoutExit(
              Number(id),
              applicationUrl,
              appName,
              iconImageUrl
            );
          } catch (err) {
            console.log(err);
            window.open("whatsapp://send?text=" + `https://www.mall91.com/#/${openLink}`);
          }
        }
        

      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    }
  }
};
</script>
